import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { InventoryAdjustRequest } from '@/lib/api-admin/types';
import { adminFetch } from '@/lib/apiClient';
import { inventoryQueryKey } from './useInventoryQuery';
import { inventoryKpiQueryKey } from './useInventoryKpiQuery';

export const useInventoryAdjustMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ inventoryId, ...body }: InventoryAdjustRequest & { inventoryId: number }) => {
      const resp = await adminFetch(`/admin/v1/inventory/${inventoryId}/adjust`, {
        method: 'POST',
        body: JSON.stringify(body),
      });
      if (!resp.ok) throw new Error(`adjust failed: ${resp.status}`);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: inventoryQueryKey({}) });
      qc.invalidateQueries({ queryKey: inventoryKpiQueryKey() });
    },
  });
};
